const commonProfileTransPath = 'profile.';
const tooltipTransPath = 'tooltips.';
const formsTransPath = commonProfileTransPath + 'formLabels.';

 const profileTranslations = {
    PROFILE_PAGE_TITLE: commonProfileTransPath + "title",
    PERSONAL_TITLE: commonProfileTransPath + "personalInformation",
    PROFESSIONAL_TITLE: commonProfileTransPath + "professionalInformation",
    PRACTICE_TITLE: commonProfileTransPath + "practiceInformation",

    FIRST_NAME_LABEL: formsTransPath + "firstName",
    LAST_NAME_LABEL: formsTransPath + "lastName",
    EMAIL_LABEL: formsTransPath + "emailAddress",
    PHONE_LABEL:formsTransPath + "phoneNumber",
    DELETE_LABEL:formsTransPath + "deleteAccount",

    TOOLTIP_EMAIL: tooltipTransPath + "email",
    TOOLTIP_NPI: tooltipTransPath + "npi"
}

export default profileTranslations